/**
 * @desc: 商户查询
 * @change：2020/4/16
 * @author: Colorfule
 * @version: v1.0
 */

import {
  merchantList,
  getMerchantAcquirerList,
  getAreaList,
  getPosAndSimCard,
  getMerchantOwner,
  updatePosAndSim,
  transferOwnership,
  updateUnionPayment,
  getMerchantApply,
  getCardState,
  getChannelApplyInfo,
  getQuotaUsage,
  getChangehistory,
  getPaymentChannel,
  unfreeze,
  freeze,
  goChannel,
  getMerLookContract,
  againContract
} from '@/api/T2/merchantCheck'

export default {
  namespaced: true,
  state: {
    checkoutListData: [],
    merNo: '',
    periodNo: ''
  },
  getters: {
    checkoutListData: state => state.checkoutListData,
    merNo: state => state.merNo,
    periodNo: state => state.periodNo
  },
  actions: {
    // 查询列表
    merchantList(ctx, payload) {
      return merchantList(payload).then(res => {
        if (res && res.status === 200) {
          return res.data
        } else {
          // 如果请求失败 那么返回空数据 防止报错
          return {
            total: 0,
            list: [],
            pages: 6
          }
        }
      })
    },

    // 区域列表
    getAreaList(ctx, payload) {
      return getAreaList(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 收单机构
    getMerchantAcquirerList(ctx, payload) {
      return getMerchantAcquirerList(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 获取商户下的支付终端信息
    getPosAndSimCard(ctx, payload) {
      return getPosAndSimCard(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 获取商户归属人员信息
    getMerchantOwner(ctx, payload) {
      return getMerchantOwner(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 系统审批信息
    getMerchantApply(ctx, payload) {
      return getMerchantApply(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 渠道审核信息
    getChannelApplyInfo(ctx, payload) {
      return getChannelApplyInfo(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 获取用户状态
    getCardState(ctx, payload) {
      return getCardState(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 更新商户的sim和pos(支付终端信息)
    async updatePosAndSim(ctx, payload) {
      return await updatePosAndSim(payload)
    },

    // 商户转移归属人员
    transferOwnership(ctx, payload) {
      return transferOwnership(payload).then(res => {
        // console.log(res, '转移归属人员')
        // return res && res.status === 200 && res.data || {}
        return res
      })
    },

    // 获取额度使用情况
    getQuotaUsage(ctx, payload) {
      return getQuotaUsage(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 更新支付终端信息
    async updateUnionPayment(ctx, payload) {
      return await updateUnionPayment(payload)
    },

    // 获取通道更新历史记录
    getChangehistory(ctx, payload) {
      return getChangehistory(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 获取通道商列表
    async getPaymentChannel(ctx, payload) {
      const data = await getPaymentChannel(payload)

      if (data && data.status === 200) {
        return data.data.reduce((prev, item) => {
          const buffer = {
            value: item.id,
            label: item.passagewayName
          }

          prev.push(buffer)
          return prev
        }, [])
      } else {
        return []
      }
    },

    // 可选通道类表
    paychannels(ctx, payload) {
      return paychannels(payload).then(res => {
        return res
      })
    },

    // 上送通道
    goChannel(ctx, payload) {
      return goChannel(payload).then(res => {
        return res && res.status === 200
      })
    },

    // 归属转移
    async postTransferMerchantOwnership(ctx, payload) {
      const res = await Models.transferMerchantOwnership(payload)
      return (res && res.status === 200 && res) || {}
    },

    // 冻结商户
    freeze(ctx, payload) {
      return freeze(payload).then(res => {
        // console.log('冻结商户', res)
        // return res && res.status === 200 && res.data || {}
        return res
      })
    },

    // 解冻商户
    unfreeze(ctx, payload) {
      return unfreeze(payload).then(res => {
        // console.log('解冻商户', res)
        // return res && res.status === 200 && res.data || {}
        return res
      })
    },

    // 合同
    getMerLookContract(ctx, payload) {
      return getMerLookContract(payload).then(res => {
        return res
      })
    },

    // 商户-签章
    againContract(ctx, payload) {
      return againContract(payload).then(res => {
        return res
      })
    },

  },

  mutations: {
    setCheckoutListData: (state, data) => {
      state.checkoutListData = data;
    },
    setMerNo: (state, data) => {
      state.merNo = data
    },
    setPeriodNo: (state, data) => {
      state.periodNo = data
    }
  }
}
